import reducer from "./reducer";
export { default as SpecialProcessDefinition } from "./components/index";
export { default as specialProcessDefinitionReducerName } from "./constants";
export default reducer;
